module.exports = __webpack_public_path__ + "img/start-bt.9581b517.png";